import { ClientInfo, HorizontalWrapper } from './styles'
import { useTranslation } from 'react-i18next'
import { Domiciliation } from 'globals/models/Domiciliation'
import { format } from 'date-fns'
import { useLazyQuery } from '@apollo/client'
import { MailTagSheetResult, MailTagSheetVariables, MAIL_TAG_SHEET } from '../ClientActionsTab/queries'
import { displayErrors } from 'globals/graphql'
import GraphQLHandler from 'components/GraphQLHandler'
import { mailTagSheetQueryRetrieved } from '../ClientActionsTab'
import { Link } from 'react-router-dom'

interface IProps {
  domiciliation: Domiciliation
}

const ClientInfos = (props: IProps) => {
  const { domiciliation } = props
  const { t } = useTranslation()
  const ownAddress = domiciliation.address?.ownAddress

  const mailTagSheetQuery = useLazyQuery<
  MailTagSheetResult, MailTagSheetVariables
  >(MAIL_TAG_SHEET, { ...displayErrors, onCompleted: mailTagSheetQueryRetrieved, fetchPolicy: 'no-cache' })

  return (
    <GraphQLHandler
      lazyQueries={{
        mailTagSheet: mailTagSheetQuery
      }}
    >
      {({
        lazyQueries: {
          mailTagSheet: [getMailTagSheetQuery]
        }
      }) =>
        <HorizontalWrapper>
          <div>
            {
              !ownAddress && domiciliation.forwardingAddress &&
          <ClientInfo>
            <b>{t('clients.forward-address')} :</b><br />

            <span>{domiciliation.forwardingAddress.name}</span><br />
            {domiciliation.forwardingAddress.streetAddress}<br />
            {domiciliation.forwardingAddress.postalCode} {domiciliation.forwardingAddress.city}<br />
            <br />
            <Link to='#' onClick={() => getMailTagSheetQuery({ variables: { domiciliationId: domiciliation.id } })}>
              {t('clients.print')}
            </Link>
          </ClientInfo>
            }

            <ClientInfo>
              <b>{t('clients.next-forward')} :</b><br/>
              {domiciliation.nextForwardingDate &&
                <>{format(new Date(domiciliation.nextForwardingDate), 'dd/MM/yyyy')}{' '}</>
              }
                ({t('clients.forward-frequency-title')}{': '}
              {t('clients.forward-frequency', { number: domiciliation.mailForwardingFrequency })})
            </ClientInfo>
          </div>

          <div>
            {domiciliation.contactOfSharings && domiciliation.contactOfSharings.length > 0 &&
          <ClientInfo>
            <b>{t('clients.trust-contacts')} :</b><br/>
            {domiciliation.contactOfSharings.map((contact, index) =>
              <>
                {index + 1} - {contact.firstname} {contact.lastname} <br/>
              </>
            )}
          </ClientInfo>
            }
          </div>
        </HorizontalWrapper>
      }
    </GraphQLHandler>
  )
}

export default ClientInfos
